import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getSaleQrAvailability } from "../../services/sale.service";

const PaymentMethodSelector = ({ options, selectedOption, onSelect }) => {
  const checkboxStyle = {
    marginRight: "8px",
  };

  const listItemStyle = {
    display: "flex",
    alignItems: "center",
    marginRight: "8px",
  };

  return (
    <div className='flex flex-wrap gap-4 w-full'>
      {options.map((option) => (
        <div
          key={option}
          style={listItemStyle}
          className='bg-gray-300 dark:bg-gray-800 p-2 rounded w-full  '
        >
          <input
            id={`payment-method-${option.toLowerCase().replace(/\s/g, "-")}`}
            type='checkbox'
            style={checkboxStyle}
            checked={selectedOption === option}
            onChange={() => onSelect(option)}
            className='w-4 h-4 mr-2 text-blue-600 bg-gray-500 border-gray-300 rounded dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600' // Adjust input size and spacing
          />
          <label
            htmlFor={`payment-method-${option
              .toLowerCase()
              .replace(/\s/g, "-")}`}
            className='text-sm font-medium text-blue-900 dark:text-white'
          >
            {option}
          </label>
        </div>
      ))}
    </div>
  );
};

export const SCANNER_PAYMENT_OPTION = "Pay by Scanner";

const PaymentOptions = ({
  handleChangePaymentMethod,
  totalAmount,
  values,
  businessUuid,
  allowScanner = true,
}) => {
  const { t } = useTranslation();
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("Cash");
  const [hasGateway, setHasGateway] = useState(false);

  useEffect(() => {
    if (!businessUuid || !allowScanner) return;
    let cancelled = false;
    getSaleQrAvailability(businessUuid)
      .then((d) => {
        if (!d?.available) {
          console.warn("Pay by Scanner hidden:", d?.reason || "gateway unavailable");
        }
        if (!cancelled) setHasGateway(!!d?.available);
      })
      .catch((e) => {
        console.warn(
          "Pay by Scanner hidden: availability check failed",
          e?.response?.status,
          e?.response?.data || e?.message,
        );
        if (!cancelled) setHasGateway(false);
      });
    return () => {
      cancelled = true;
    };
  }, [businessUuid, allowScanner]);

  const options = ["UPI", "Cash"];
  if (hasGateway && allowScanner) options.push(SCANNER_PAYMENT_OPTION);

  const handlePaymentMethodSelect = (method) => {
    setSelectedPaymentMethod(method);
  };
  const handleSubmit = () => {
    values["paymentMode"] = selectedPaymentMethod;
    values["remainingTransactionAmount"] = 0;
    handleChangePaymentMethod(values);
  };

  return (
    <div className='flex flex-col justify-end p-4'>
      <PaymentMethodSelector
        // options={["Credit Card", "Debit Card", "Netbanking", "Wallets", "Cash"]}
        // options={["UPI", "Cash", "Pinelabs Pos", "PhonePe Pos", "RozarPe Pos"]}
        options={options}
        selectedOption={selectedPaymentMethod}
        onSelect={handlePaymentMethodSelect}
      />
      <div className='flex justify-between items-center mt-4'>
        <div className='mr-auto'>
          <div className='border-b border-blue-600 inline-block'>
            {t("COMMON.TOTAL")}
          </div>
          <div className='border-blue-600'>₹{totalAmount || 0}</div>
        </div>
        <button
          className='bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded'
          onClick={handleSubmit}
        >
          Ok
        </button>
      </div>
    </div>
  );
};

export default PaymentOptions;
